module.exports = __webpack_public_path__ + "static/media/aanchal_singh.95ad7297.jpg";